<template>
  <div>
    <v-container grid-list-xl>
      <v-layout wrap justify-space-between>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title
              >Has Ortalama: {{ hasAverage | formatMoney }}</v-toolbar-title
            >
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugünkü Siparişler</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.$store.state.reports.orderReports"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatState }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugünkü Uyum Fatura Durumları</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.uyumDaily"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatUyumStates }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Siparişler Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.orderMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatState }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Uyum Fatura Durumları Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.uyumMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  {{ props.item.state | formatUyumStates }}
                </td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Bugün En Çok Satılanlar</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="productHeaders"
            :loading="this.$store.state.progress"
            :items="this.$store.state.reports.bestSellingProducts"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>En Çok Satılanlar Son 1 Ay</v-toolbar-title>
          </v-toolbar>
          <v-data-table
            :headers="productHeaders"
            :pagination.sync="pagination"
            :loading="this.$store.state.progress"
            :items="this.productMonthly"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <!-- Tarih Aralığına Göre Gönderilen Altın Özeti -->
        <v-flex xs12 class="mb-4">
          <v-card class="elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">date_range</v-icon>
              <span class="font-weight-bold">Tarih Aralığına Göre Gönderilen Altın Özeti</span>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm4 class="px-2">
                  <v-menu
                    v-model="goldSentStartDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="goldSentStartDate"
                        label="Başlangıç Tarihi"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="goldSentStartDate"
                      locale="tr-TR"
                      @input="goldSentStartDateMenu = false; loadTotalGoldSentBetweenDates()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4 class="px-2">
                  <v-menu
                    v-model="goldSentEndDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="goldSentEndDate"
                        label="Bitiş Tarihi"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="goldSentEndDate"
                      locale="tr-TR"
                      @input="goldSentEndDateMenu = false; loadTotalGoldSentBetweenDates()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="goldSentHeaders"
                :items="goldSentTableItems"
                :loading="goldSentLoading"
                hide-actions
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.label }}</td>
                    <td class="text-xs-right font-weight-bold">{{ props.item.value }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- E-Altın Banka Özetleri (Sadece TenantId = 2 için) -->
        <v-flex xs12 mt-4 v-if="tenantId === 2">
          <v-layout row wrap>
            <!-- Yeni Sipariş Toplamları Tablosu -->
            <v-flex xs12 md6>
              <v-card class="elevation-4">
                <v-card-title class="amber darken-2 white--text">
                  <v-icon left color="white">new_releases</v-icon>
                  <span class="font-weight-bold">Banka Bazında Yeni Sipariş Toplamları</span>
                </v-card-title>
                
                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 class="px-2">
                      <v-menu
                        v-model="newOrdersStartDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newOrdersStartDate"
                            label="Başlangıç Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newOrdersStartDate"
                          locale="tr-TR"
                          @input="newOrdersStartDateMenu = false; loadNewOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-2">
                      <v-menu
                        v-model="newOrdersEndDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newOrdersEndDate"
                            label="Bitiş Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newOrdersEndDate"
                          locale="tr-TR"
                          @input="newOrdersEndDateMenu = false; loadNewOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="newOrdersHeaders"
                    :items="newOrdersSummary"
                    :loading="newOrdersLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr :class="props.item.bankName === 'DİĞER (1000 milyem)' ? 'grey lighten-3' : ''">
                        <td class="font-weight-bold">{{ props.item.bankName }}</td>
                        <td class="text-xs-right">{{ formatGold(props.item.currentGoldAmount) }}</td>
                        <td class="text-xs-right amber--text text--darken-3 font-weight-bold">
                          {{ formatGold(props.item.totalGoldAmount) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarih aralığında yeni sipariş bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Gönderilen Sipariş Toplamları Tablosu -->
            <v-flex xs12 md6>
              <v-card class="elevation-4">
                <v-card-title class="success white--text">
                  <v-icon left color="white">done_all</v-icon>
                  <span class="font-weight-bold">Banka Bazında Gönderilen Sipariş Toplamları</span>
                </v-card-title>
                
                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 class="px-2">
                      <v-menu
                        v-model="completedOrdersDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="completedOrdersDate"
                            label="İşlem Tarihi"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="completedOrdersDate"
                          locale="tr-TR"
                          @input="completedOrdersDateMenu = false; loadCompletedOrdersSummary()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="completedOrdersHeaders"
                    :items="completedOrdersSummary"
                    :loading="completedOrdersLoading"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td class="font-weight-bold">{{ props.item.bankName }}</td>
                        <td class="text-xs-right">{{ formatGold(props.item.currentGoldAmount) }}</td>
                        <td class="text-xs-right success--text font-weight-bold">
                          {{ formatGold(props.item.totalGoldAmount) }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarihte gönderilen sipariş bulunmamaktadır.
                      </v-alert>
                    </template>
                    <template v-slot:footer v-if="completedOrdersSummary.length">
                      <tr class="success lighten-4" style="border-top: 2px solid #4caf50;">
                        <td class="font-weight-bold text-uppercase">Toplam</td>
                        <td class="text-xs-right font-weight-bold">{{ formatGold(completedOrdersTotalCurrentGold) }}</td>
                        <td class="text-xs-right success--text font-weight-bold">{{ formatGold(completedOrdersTotalGold) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- Gün Bazında Sipariş Kontrol -->
          <v-layout row wrap class="mt-4">
            <v-flex xs12>
              <v-card class="elevation-4">
                <v-card-title class="indigo darken-2 white--text">
                  <v-icon left color="white">table_chart</v-icon>
                  <span class="font-weight-bold">Gün Bazında Sipariş Kontrol</span>
                </v-card-title>

                <v-card-text class="pa-3">
                  <!-- Filtre -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm4 class="px-2">
                      <v-menu
                        v-model="ealtinOrderControlDateMenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="ealtinOrderControlDate"
                            label="Tarih"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            dense
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="ealtinOrderControlDate"
                          locale="tr-TR"
                          @input="ealtinOrderControlDateMenu = false; loadEaltinOrderControl()"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm4 class="px-2">
                      <v-combobox
                        v-model="selectedEaltinOrderControlCities"
                        :items="ealtinOrderControlCityOptions"
                        label="Şehir"
                        prepend-icon="location_city"
                        multiple
                        clearable
                        dense
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm4 class="px-2 d-flex align-center justify-end">
                      <span class="red--text font-weight-bold">
                        Toplam: {{ formatNumber(ealtinOrderControlTotalExpectedSum) }}
                      </span>
                    </v-flex>
                  </v-layout>

                  <!-- Özet (tablodaki verilerden) -->
                  <v-layout row wrap class="mb-3">
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam KDV</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.totalVat + ealtinOrderControlTotals.commissionVat) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Stopaj</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.withholding) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam İşçilik</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.labor) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Komisyon</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.commission) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Komisyon KDV'li</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.commissionWithVat) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Toplam Hizmet Bedeli</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlTotals.serviceFee) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Ortalama Has</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlAverages.avgHasPrice) }}
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-2 mb-2">
                      <v-card outlined class="pa-2">
                        <div class="caption grey--text text--darken-1">Ortalama Satış Fiyatı</div>
                        <div class="subtitle-1 font-weight-bold">
                          {{ formatNumber(ealtinOrderControlAverages.avgSalesPrice) }}
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <!-- Tablo -->
                  <v-data-table
                    :headers="ealtinOrderControlHeaders"
                    :items="filteredEaltinOrderControlList"
                    :loading="ealtinOrderControlLoading"
                    :pagination.sync="ealtinOrderControlPagination"
                    hide-actions
                    class="elevation-1 ealtin-order-control-table"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td>{{ formatDateOnly(props.item.date) }}</td>
                        <td class="text-no-wrap">{{ props.item.iban }}</td>
                        <td class="text-no-wrap">{{ props.item.bank }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.grams) }}</td>
                        <td class="text-no-wrap">{{ props.item.orderNumber }}</td>
                        <td class="text-no-wrap">{{ props.item.customerName }}</td>
                        <td class="text-no-wrap">{{ props.item.shippingCity }}</td>
                        <td class="text-no-wrap">{{ props.item.productCode }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.unitPrice) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.invoiceAmount) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commission) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commissionVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.commissionWithVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber((props.item.totalVat || 0) + (props.item.commissionVat || 0)) }}</td>
                        <td class="text-xs-right font-weight-bold">{{ formatNumber(props.item.totalExpected) }}</td>
                        <td class="text-xs-right">{{ formatGramTruncate(props.item.totalGramWeight) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.hasPrice) }}</td>
                        <td class="text-xs-right">{{ props.item.foreksHas == null ? '-' : formatNumber(props.item.foreksHas) }}</td>
                        <td class="text-xs-right">{{ props.item.averageSalesExchange == null ? '-' : formatNumber(props.item.averageSalesExchange) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.salesAmount) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.labor) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.totalVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.laborWithVat) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.withholding) }}</td>
                        <td class="text-xs-right">{{ formatNumber(props.item.serviceFee) }}</td>
                      </tr>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" color="info" icon="info">
                        Seçilen tarihte kayıt bulunmamaktadır.
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <mint-agreement-summary-card ref="mintSummaryCard" />

        <!-- Altındafırsat Gün Bazında Sipariş Kontrol (Sadece TenantId = 1 için) -->
        <v-flex xs12 mt-4 v-if="tenantId === 1">
          <v-card class="elevation-4">
            <v-card-title class="amber darken-3 white--text">
              <v-icon left color="white">assignment_turned_in</v-icon>
              <span class="font-weight-bold">Gün Bazında Sipariş Kontrol</span>
              <v-spacer></v-spacer>
              <v-btn small color="white" class="amber--text text--darken-3 ma-0" @click="openBarcodeDialog">
                <v-icon left small>qr_code_scanner</v-icon>
                Barkod Okut
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-3">
              <!-- Tarih Filtresi -->
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm3 class="px-2">
                  <v-menu
                    v-model="altindafirsatOrderControlDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="altindafirsatOrderControlDate"
                        label="Tarih"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="altindafirsatOrderControlDate"
                      locale="tr-TR"
                      @input="altindafirsatOrderControlDateMenu = false; loadAltindafirsatOrderControl()"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 class="px-2">
                  <v-combobox
                    v-model="selectedAltindafirsatOrderControlCities"
                    :items="altindafirsatOrderControlCityOptions"
                    label="Şehir"
                    prepend-icon="location_city"
                    multiple
                    clearable
                    dense
                  ></v-combobox>
                </v-flex>
                <v-flex xs12 sm3 class="px-2 d-flex align-center">
                  <v-menu offset-y :close-on-content-click="false" max-height="420">
                    <template v-slot:activator="{ on }">
                      <v-btn small color="amber darken-3" class="white--text" v-on="on">
                        <v-icon left small>view_column</v-icon>
                        Sütunlar ({{ altindafirsatToggleableColumns.length - altindafirsatHiddenColumns.length }}/{{ altindafirsatToggleableColumns.length }})
                      </v-btn>
                    </template>
                    <v-card>
                      <v-list dense class="py-0">
                        <v-list-tile @click="toggleAllAltindafirsatColumns">
                          <v-list-tile-action>
                            <v-icon small>{{ altindafirsatHiddenColumns.length === 0 ? 'check_box' : (altindafirsatHiddenColumns.length === altindafirsatToggleableColumns.length ? 'check_box_outline_blank' : 'indeterminate_check_box') }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-bold">Tümünü Seç / Kaldır</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-list-tile
                          v-for="col in altindafirsatToggleableColumns"
                          :key="col.value"
                          @click="toggleAltindafirsatColumn(col.value)"
                        >
                          <v-list-tile-action>
                            <v-icon small>{{ altindafirsatHiddenColumns.includes(col.value) ? 'check_box_outline_blank' : 'check_box' }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ col.text }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm3 class="px-2 d-flex align-center justify-end">
                  <span class="red--text font-weight-bold">
                    Toplam Fatura: {{ formatNumber(altindafirsatTotals.invoiceAmount) }}
                  </span>
                </v-flex>
              </v-layout>

              <!-- Özet Kartları -->
              <v-layout row wrap class="mb-3">
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Komisyon (KDV'li)</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.commissionWithVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Sigorta (KDV'li)</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.insuranceWithVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam İşçilik (KDV'li)</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.laborInclVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Stopaj</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.withholding) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Fatura KDV</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.invoiceVat) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam Net Satış Tutarı</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.netSalesAmount) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">HB'den Beklenen Nakit</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.netCash) }}
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6 md3 class="px-2 mb-2">
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">Toplam G.gramaj</div>
                    <div class="subtitle-1 font-weight-bold">
                      {{ formatNumber(altindafirsatTotals.totalPureGram) }}
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>

              <!-- Tablo -->
              <v-data-table
                :headers="altindafirsatVisibleHeaders"
                :items="filteredAltindafirsatOrderControlList"
                :loading="altindafirsatOrderControlLoading"
                :pagination.sync="altindafirsatOrderControlPagination"
                hide-actions
                class="elevation-1 altindafirsat-order-control-table"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-right">{{ props.item.rowNo }}</td>
                    <td class="text-no-wrap">{{ props.item.indicator }}</td>
                    <td class="text-no-wrap">{{ formatDateTime(props.item.orderDate) }}</td>
                    <td class="text-no-wrap">{{ props.item.barcode }}</td>
                    <td class="text-no-wrap">{{ props.item.identityNo }}</td>
                    <td class="text-no-wrap">{{ props.item.orderNumber }}</td>
                    <td class="text-no-wrap">{{ props.item.customerName }}</td>
                    <td class="text-no-wrap">{{ props.item.shippingCity }}</td>
                    <td class="text-no-wrap">{{ props.item.productName }}</td>
                    <td class="text-xs-right">{{ props.item.quantity }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.unitPrice) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.invoiceAmount) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commission')" class="text-xs-right">{{ formatNumber(props.item.commission) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionVat')" class="text-xs-right">{{ formatNumber(props.item.commissionVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionWithVat')" class="text-xs-right">{{ formatNumber(props.item.commissionWithVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('insurance')" class="text-xs-right">{{ formatNumber(props.item.insurance) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('insuranceVat')" class="text-xs-right">{{ formatNumber(props.item.insuranceVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('insuranceWithVat')" class="text-xs-right">{{ formatNumber(props.item.insuranceWithVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionPlusInsurance')" class="text-xs-right">{{ formatNumber(props.item.commissionPlusInsurance) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('commissionVatPlusInsuranceVat')" class="text-xs-right">{{ formatNumber(props.item.commissionVatPlusInsuranceVat) }}</td>
                    <td v-if="isAltindafirsatColumnVisible('invoiceVat')" class="text-xs-right">{{ formatNumber(props.item.invoiceVat) }}</td>
                    <td class="text-xs-right font-weight-bold">{{ formatNumber(props.item.netCash) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.withholding) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.unitGram) }}</td>
                    <td class="text-xs-right">{{ props.item.purity }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.totalRawGram) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.totalPureGram) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.salesHasPrice) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.netSalesAmount) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.labor) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.laborVat) }}</td>
                    <td class="text-xs-right">{{ formatNumber(props.item.laborInclVat) }}</td>
                    <td class="text-no-wrap">{{ props.item.link }}</td>
                    <td class="text-no-wrap">{{ props.item.shippingStatus }}</td>
                    <td class="text-no-wrap">{{ props.item.shippedBarcode }}</td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <v-alert :value="true" color="info" icon="info">
                    Seçilen tarihte kayıt bulunmamaktadır.
                  </v-alert>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="barcodeDialogOpen" persistent max-width="640">
      <v-card>
        <v-card-title class="amber darken-3 white--text">
          <v-icon left color="white">qr_code_scanner</v-icon>
          <span class="font-weight-bold">Barkod Okut</span>
          <v-spacer></v-spacer>
          <v-btn icon flat color="white" @click="closeBarcodeDialog" :disabled="barcodeConfirming">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-text-field
            ref="barcodeInputRef"
            v-model="barcodeInput"
            label="Barkod"
            placeholder="Barkodu okutun veya yazıp Enter'a basın"
            prepend-icon="qr_code"
            autofocus
            clearable
            @keyup.enter="addBarcode"
            @blur="onBarcodeInputBlur"
            :disabled="barcodeConfirming"
          ></v-text-field>

          <v-alert
            v-if="duplicateBarcodeWarning"
            :value="true"
            type="warning"
            color="orange darken-2"
            icon="warning"
            outline
            class="mb-2 py-2"
          >
            <strong>Bu barkod zaten okutuldu:</strong>
            <span class="font-weight-bold">{{ duplicateBarcodeWarning }}</span>
            <div class="caption">Yeni bir barkod okutarak devam edebilirsiniz.</div>
          </v-alert>

          <div class="caption grey--text mb-2">
            {{ scannedBarcodes.length }} barkod listede. Tek tek veya art arda okutabilirsiniz.
          </div>

          <v-list dense v-if="scannedBarcodes.length" class="elevation-1" style="max-height:220px;overflow-y:auto">
            <v-list-tile
              v-for="(b, idx) in scannedBarcodes"
              :key="idx"
              :class="{ 'duplicate-flash': duplicateFlashIdx === idx }"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ b }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon flat small @click="removeBarcode(idx)" :disabled="barcodeConfirming">
                  <v-icon small color="red">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <div v-if="barcodeConfirmResult" class="mt-3">
            <v-card
              v-if="barcodeConfirmResult.confirmed && barcodeConfirmResult.confirmed.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #43a047;background:#f1f8e9"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="green darken-2">check_circle</v-icon>
                <span class="font-weight-bold green--text text--darken-2 ml-2">
                  Onaylanan ({{ barcodeConfirmResult.confirmed.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.confirmed"
                  :key="'c-' + b"
                  small
                  color="green lighten-4"
                  text-color="green darken-3"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-card
              v-if="barcodeConfirmResult.alreadyConfirmed && barcodeConfirmResult.alreadyConfirmed.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #fb8c00;background:#fff8e1"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="orange darken-2">info</v-icon>
                <span class="font-weight-bold orange--text text--darken-2 ml-2">
                  Zaten Onaylı ({{ barcodeConfirmResult.alreadyConfirmed.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.alreadyConfirmed"
                  :key="'a-' + b"
                  small
                  color="orange lighten-4"
                  text-color="orange darken-3"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-card
              v-if="barcodeConfirmResult.notShipped && barcodeConfirmResult.notShipped.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #c62828;background:#ffebee"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="red darken-2">local_shipping</v-icon>
                <span class="font-weight-bold red--text text--darken-2 ml-2">
                  Kargo gönderildi durumuna çekilmeyenler ({{ barcodeConfirmResult.notShipped.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.notShipped"
                  :key="'s-' + b"
                  small
                  color="red lighten-4"
                  text-color="red darken-3"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>

            <v-card
              v-if="barcodeConfirmResult.notFound && barcodeConfirmResult.notFound.length"
              flat
              class="pa-2 mb-2 barcode-result-card"
              style="border-left:4px solid #424242;background:#fafafa"
            >
              <div class="d-flex align-center mb-1">
                <v-icon small color="grey darken-3">error_outline</v-icon>
                <span class="font-weight-bold grey--text text--darken-3 ml-2">
                  Bulunamayan/Geçersiz ({{ barcodeConfirmResult.notFound.length }})
                </span>
              </div>
              <div>
                <v-chip
                  v-for="b in barcodeConfirmResult.notFound"
                  :key="'n-' + b"
                  small
                  color="grey lighten-2"
                  text-color="grey darken-4"
                  class="ma-1"
                >{{ b }}</v-chip>
              </div>
            </v-card>
          </div>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-btn flat @click="clearBarcodes" :disabled="barcodeConfirming || !scannedBarcodes.length">
            Listeyi Temizle
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeBarcodeDialog" :disabled="barcodeConfirming">Kapat</v-btn>
          <v-btn
            color="amber darken-3"
            class="white--text"
            :loading="barcodeConfirming"
            :disabled="!scannedBarcodes.length || barcodeConfirming"
            @click="confirmBarcodes"
          >
            <v-icon left small>check</v-icon>
            Onayla
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
import Api from "@/api/baseApi";
import orders from "@/api/orders";
import MintAgreementSummaryCard from "@/components/MintAgreementSummaryCard.vue";

export default {
  components: {
    MintAgreementSummaryCard,
  },
  filters: {
    formatState: function(value) {
      var result = store.getters["orders/getStateItems"].find(
        (el) => el.id == value
      );
      return result.value;
    },
  },
  data: () => {
    const d = new Date();
    const start = new Date(d);
    start.setDate(start.getDate() - 30);
    const end = new Date(d);
    end.setDate(end.getDate() + 1);
    return {
    // Tarih aralığına göre gönderilen altın (varsayılan: son 1 ay)
    goldSentStartDate: start.toISOString().substr(0, 10),
    goldSentEndDate: end.toISOString().substr(0, 10),
    goldSentStartDateMenu: false,
    goldSentEndDateMenu: false,
    goldSentLoading: false,
    goldSentData: { totalGoldSent: 0, totalPayment: 0 },
    goldSentHeaders: [
      { text: 'Özet', value: 'label', sortable: false },
      { text: 'Değer', value: 'value', align: 'right', sortable: false }
    ],
    productMonthly: [],
    orderMonthly: [],
    uyumMonthly: [],
    uyumDaily: [],
    hasAverage: null,
    pagination: {
      sortBy: "name",
    },
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    headers: [
      {
        text: "Sipariş Durumu",
        value: "state",
      },
      { text: "Adet", value: "count" },
      { text: "Sipariş Tutarı", value: "totalAmount" },
    ],
    productHeaders: [
      {
        text: "Ürün",
        value: "state",
      },
      { text: "Adet", value: "count" },
      { text: "Sipariş Tutarı", value: "totalAmount" },
    ],
    // E-Altın Banka Özetleri
    newOrdersStartDate: new Date().toISOString().substr(0, 10),
    newOrdersEndDate: new Date().toISOString().substr(0, 10),
    newOrdersStartDateMenu: false,
    newOrdersEndDateMenu: false,
    newOrdersSummary: [],
    newOrdersLoading: false,
    newOrdersHeaders: [
      { text: 'Banka Adı', value: 'bankName', sortable: false },
      { text: 'Bankadaki Altın Miktarı(GR)', value: 'currentGoldAmount', align: 'right', sortable: false },
      { text: 'Yeni Sipariş Toplamı(GR)', value: 'totalGoldAmount', align: 'right', sortable: false }
    ],
    completedOrdersDate: new Date().toISOString().substr(0, 10),
    completedOrdersDateMenu: false,
    completedOrdersSummary: [],
    completedOrdersLoading: false,
    completedOrdersHeaders: [
      { text: 'Banka Adı', value: 'bankName', sortable: false },
      { text: 'Bankadaki Altın Miktarı(GR)', value: 'currentGoldAmount', align: 'right', sortable: false },
      { text: 'Gönderilen Altın Toplamı(GR)', value: 'totalGoldAmount', align: 'right', sortable: false }
    ],

    // Gün Bazında Sipariş Kontrol (E-Altın)
    ealtinOrderControlDate: new Date().toISOString().substr(0, 10),
    ealtinOrderControlDateMenu: false,
    ealtinOrderControlLoading: false,
    ealtinOrderControlList: [],
    ealtinOrderControlPagination: { rowsPerPage: -1 },
    selectedEaltinOrderControlCities: [],
    ealtinOrderControlHeaders: [
      { text: 'Tarih', value: 'date', sortable: false },
      { text: 'IBAN', value: 'iban', sortable: false },
      { text: 'BANKA', value: 'bank', sortable: false },
      { text: 'GRAM', value: 'grams', align: 'right', sortable: false },
      { text: 'SİPARİŞ NO', value: 'orderNumber', sortable: false },
      { text: 'İSİM', value: 'customerName', sortable: false },
      { text: 'ŞEHİR', value: 'shippingCity', sortable: false },
      { text: 'KOD(Ürün adı)', value: 'productCode', sortable: false },
      { text: 'Adet', value: 'quantity', align: 'right', sortable: false },
      { text: 'Birim Fiyatı', value: 'unitPrice', align: 'right', sortable: false },
      { text: 'Fatura Tutarı', value: 'invoiceAmount', align: 'right', sortable: false },
      { text: 'Komisyon', value: 'commission', align: 'right', sortable: false },
      { text: 'Komisyon KDVSİ', value: 'commissionVat', align: 'right', sortable: false },
      { text: 'Komisyon + komisyon Kdvsi', value: 'commissionWithVat', align: 'right', sortable: false },
      { text: 'Toplam KDV', value: 'eGoldVat', align: 'right', sortable: false },
      { text: 'Toplam', value: 'totalExpected', align: 'right', sortable: false },
      { text: 'Toplam Gramaj', value: 'totalGramWeight', align: 'right', sortable: false },
      { text: 'Has Fiyatı', value: 'hasPrice', align: 'right', sortable: false },
      { text: 'Foreks Has', value: 'foreksHas', align: 'right', sortable: false },
      { text: 'Ortalama Satış Döviz', value: 'averageSalesExchange', align: 'right', sortable: false },
      { text: 'Satış Tutarı', value: 'salesAmount', align: 'right', sortable: false },
      { text: 'İşçilik', value: 'labor', align: 'right', sortable: false },
      { text: 'İşçilik KDVsi', value: 'totalVat', align: 'right', sortable: false },
      { text: 'Kdvli İşçilik', value: 'laborWithVat', align: 'right', sortable: false },
      { text: 'Stopaj', value: 'withholding', align: 'right', sortable: false },
      { text: 'Hizmet Bedeli', value: 'serviceFee', align: 'right', sortable: false },
    ],

    // Altındafırsat Gün Bazında Sipariş Kontrol
    altindafirsatOrderControlDate: new Date().toISOString().substr(0, 10),
    altindafirsatOrderControlDateMenu: false,
    altindafirsatOrderControlLoading: false,
    altindafirsatOrderControlList: [],
    altindafirsatOrderControlPagination: { rowsPerPage: -1 },
    selectedAltindafirsatOrderControlCities: [],

    // Barkod Okutma Modal
    barcodeDialogOpen: false,
    barcodeInput: '',
    scannedBarcodes: [],
    barcodeConfirming: false,
    barcodeConfirmResult: null,
    duplicateBarcodeWarning: null,
    duplicateFlashIdx: null,
    duplicateFlashTimer: null,
    altindafirsatOrderControlHeaders: [
      { text: 'Sıra No', value: 'rowNo', align: 'right', sortable: false },
      { text: 'Etiket No', value: 'indicator', sortable: false },
      { text: 'Sipariş Tarihi', value: 'orderDate', sortable: false },
      { text: 'Barkod', value: 'barcode', sortable: false },
      { text: 'T.C Kimlik No', value: 'identityNo', sortable: false },
      { text: 'Sipariş No', value: 'orderNumber', sortable: false },
      { text: 'İsim', value: 'customerName', sortable: false },
      { text: 'Şehir', value: 'shippingCity', sortable: false },
      { text: 'Ürün', value: 'productName', sortable: false },
      { text: 'Adet', value: 'quantity', align: 'right', sortable: false },
      { text: 'Birim Fiyatı', value: 'unitPrice', align: 'right', sortable: false },
      { text: 'Fatura Tutarı', value: 'invoiceAmount', align: 'right', sortable: false },
      { text: 'HB Kom.', value: 'commission', align: 'right', sortable: false },
      { text: 'HB KDV', value: 'commissionVat', align: 'right', sortable: false },
      { text: 'HB KOM.+ KDV', value: 'commissionWithVat', align: 'right', sortable: false },
      { text: 'Sigorta Bedeli', value: 'insurance', align: 'right', sortable: false },
      { text: 'Sigorta KDV', value: 'insuranceVat', align: 'right', sortable: false },
      { text: 'KDVLİ Sigorta Bedeli', value: 'insuranceWithVat', align: 'right', sortable: false },
      { text: 'HB KOM.+ Sigorta', value: 'commissionPlusInsurance', align: 'right', sortable: false },
      { text: 'HB KDV+ Sigorta KDV', value: 'commissionVatPlusInsuranceVat', align: 'right', sortable: false },
      { text: 'FT. KDV', value: 'invoiceVat', align: 'right', sortable: false },
      { text: 'Toplam', value: 'netCash', align: 'right', sortable: false },
      { text: 'Stopaj', value: 'withholding', align: 'right', sortable: false },
      { text: 'Adet Ağırlığı', value: 'unitGram', align: 'right', sortable: false },
      { text: 'Mly', value: 'purity', align: 'right', sortable: false },
      { text: 'T.gramaj', value: 'totalRawGram', align: 'right', sortable: false },
      { text: 'G.gramaj', value: 'totalPureGram', align: 'right', sortable: false },
      { text: 'Satış Has Fiyatı', value: 'salesHasPrice', align: 'right', sortable: false },
      { text: 'Satış Tutarı (Birim)', value: 'netSalesAmount', align: 'right', sortable: false },
      { text: 'İşçilik', value: 'labor', align: 'right', sortable: false },
      { text: 'AF KDV', value: 'laborVat', align: 'right', sortable: false },
      { text: "KDV'li İşçilik", value: 'laborInclVat', align: 'right', sortable: false },
      { text: 'Bağlantı', value: 'link', sortable: false },
      { text: 'Gönderim Durumu', value: 'shippingStatus', sortable: false },
      { text: 'Gönderilen Siparişler', value: 'shippedBarcode', sortable: false },
    ],
    altindafirsatToggleableColumnValues: [
      'commission',
      'commissionVat',
      'commissionWithVat',
      'insurance',
      'insuranceVat',
      'insuranceWithVat',
      'commissionPlusInsurance',
      'commissionVatPlusInsuranceVat',
      'invoiceVat',
    ],
    altindafirsatHiddenColumns: JSON.parse(localStorage.getItem('altindafirsatHiddenColumns') || '[]'),
  };
  },
  computed: {
    goldSentTableItems() {
      return [
        { label: 'Toplam Gönderilen Altın (GR)', value: this.formatGold(this.goldSentData.totalGoldSent) },
        { label: 'Toplam Ödeme (TL)', value: (this.goldSentData.totalPayment || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺' }
      ];
    },
    tenantId() { 
      const savedTenantId = localStorage.getItem('selectedTenantId');
      return savedTenantId ? parseInt(savedTenantId) : 0;
    }
    ,
    completedOrdersTotalCurrentGold() {
      return (this.completedOrdersSummary || []).reduce((sum, row) => sum + (Number(row.currentGoldAmount) || 0), 0);
    },
    completedOrdersTotalGold() {
      return (this.completedOrdersSummary || []).reduce((sum, row) => sum + (Number(row.totalGoldAmount) || 0), 0);
    },
    ealtinOrderControlCityOptions() {
      const list = this.ealtinOrderControlList || [];
      const set = new Set();
      list.forEach((row) => {
        if (row.shippingCity) set.add(row.shippingCity);
      });
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'tr'));
    },
    filteredEaltinOrderControlList() {
      const list = this.ealtinOrderControlList || [];
      const cities = (this.selectedEaltinOrderControlCities || []).filter((c) => !!c);
      if (cities.length === 0) return list;
      const set = new Set(cities);
      return list.filter((row) => row.shippingCity && set.has(row.shippingCity));
    },
    ealtinOrderControlTotalExpectedSum() {
      const list = this.filteredEaltinOrderControlList || [];
      return list.reduce((sum, row) => sum + (Number(row.totalExpected) || 0), 0);
    },
    ealtinOrderControlTotals() {
      const list = this.filteredEaltinOrderControlList || [];
      return list.reduce(
        (acc, row) => {
          acc.totalVat += Number(row.totalVat) || 0;
          acc.commissionVat += Number(row.commissionVat) || 0;
          acc.withholding += Number(row.withholding) || 0;
          acc.labor += Number(row.labor) || 0;
          acc.commission += Number(row.commission) || 0;
          acc.commissionWithVat += Number(row.commissionWithVat) || 0;
          acc.serviceFee += Number(row.serviceFee) || 0;
          return acc;
        },
        { totalVat: 0, commissionVat: 0, withholding: 0, labor: 0, commission: 0, commissionWithVat: 0, serviceFee: 0 }
      );
    },
    ealtinOrderControlAverages() {
      const list = this.filteredEaltinOrderControlList || [];
      const acc = list.reduce(
        (a, row) => {
          const weight =
            (Number(row.totalGramWeight) || 0) ||
            (Number(row.grams) || 0) ||
            0;
          const hasPrice = Number(row.hasPrice) || 0;
          const salesAmount = Number(row.salesAmount) || 0;

          a.weightSum += weight;
          a.hasWeightedSum += hasPrice * weight;
          a.salesWeightedSum += salesAmount * weight;
          return a;
        },
        { weightSum: 0, hasWeightedSum: 0, salesWeightedSum: 0 }
      );

      const avgHasPrice = acc.weightSum ? acc.hasWeightedSum / acc.weightSum : 0;
      const avgSalesPrice = acc.weightSum ? acc.salesWeightedSum / acc.weightSum : 0;

      return { avgHasPrice, avgSalesPrice };
    },
    altindafirsatOrderControlCityOptions() {
      const list = this.altindafirsatOrderControlList || [];
      const set = new Set();
      list.forEach((row) => {
        if (row.shippingCity) set.add(row.shippingCity);
      });
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'tr'));
    },
    filteredAltindafirsatOrderControlList() {
      const list = this.altindafirsatOrderControlList || [];
      const cities = (this.selectedAltindafirsatOrderControlCities || []).filter((c) => !!c);
      if (cities.length === 0) return list;
      const set = new Set(cities);
      return list.filter((row) => row.shippingCity && set.has(row.shippingCity));
    },
    altindafirsatTotals() {
      const list = this.filteredAltindafirsatOrderControlList || [];
      return list.reduce(
        (acc, row) => {
          acc.invoiceAmount += Number(row.invoiceAmount) || 0;
          acc.commission += Number(row.commission) || 0;
          acc.commissionWithVat += Number(row.commissionWithVat) || 0;
          acc.insurance += Number(row.insurance) || 0;
          acc.insuranceWithVat += Number(row.insuranceWithVat) || 0;
          acc.labor += Number(row.labor) || 0;
          acc.laborInclVat += Number(row.laborInclVat) || 0;
          acc.withholding += Number(row.withholding) || 0;
          acc.invoiceVat += Number(row.invoiceVat) || 0;
          acc.netCash += Number(row.netCash) || 0;
          acc.netSalesAmount += Number(row.netSalesAmount) || 0;
          acc.totalPureGram += Number(row.totalPureGram) || 0;
          return acc;
        },
        {
          invoiceAmount: 0, commission: 0, commissionWithVat: 0,
          insurance: 0, insuranceWithVat: 0, labor: 0, laborInclVat: 0,
          withholding: 0, invoiceVat: 0, netCash: 0, netSalesAmount: 0,
          totalPureGram: 0
        }
      );
    },
    altindafirsatToggleableColumns() {
      const set = new Set(this.altindafirsatToggleableColumnValues);
      return this.altindafirsatOrderControlHeaders.filter((h) => set.has(h.value));
    },
    altindafirsatVisibleHeaders() {
      return this.altindafirsatOrderControlHeaders.filter(
        (h) => !this.altindafirsatHiddenColumns.includes(h.value)
      );
    }
  },
  methods: {
    isAltindafirsatColumnVisible(value) {
      return !this.altindafirsatHiddenColumns.includes(value);
    },
    toggleAltindafirsatColumn(value) {
      const idx = this.altindafirsatHiddenColumns.indexOf(value);
      if (idx >= 0) {
        this.altindafirsatHiddenColumns.splice(idx, 1);
      } else {
        this.altindafirsatHiddenColumns.push(value);
      }
      localStorage.setItem(
        'altindafirsatHiddenColumns',
        JSON.stringify(this.altindafirsatHiddenColumns)
      );
    },
    toggleAllAltindafirsatColumns() {
      if (this.altindafirsatHiddenColumns.length === 0) {
        this.altindafirsatHiddenColumns = this.altindafirsatToggleableColumnValues.slice();
      } else {
        this.altindafirsatHiddenColumns = [];
      }
      localStorage.setItem(
        'altindafirsatHiddenColumns',
        JSON.stringify(this.altindafirsatHiddenColumns)
      );
    },
    getDate(day) {
      return new Date()
        .addDays(day)
        .toISOString()
        .substr(0, 10);
    },
    async initialize() {
      const today = new Date().toISOString().substr(0, 10);
      await Promise.all([
        this.$store.dispatch("reports/getOrderReports", {
          startDate: today,
          endDate: today,
        }),
        this.$store.dispatch("reports/getBestSellingProductsReports", {
          startDate: today,
          endDate: today,
        }),
        Api.get(
          `api/reports/GetOrderUyumStateReports?startDate=${this.getDate(
            -30
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.uyumMonthly = r.data; }),
        Api.get(
          `api/reports/GetOrderUyumStateReports?startDate=${this.getDate(
            0
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.uyumDaily = r.data; }),
        Api.get(
          `api/reports/GetOrderReports?startDate=${this.getDate(
            -30
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.orderMonthly = r.data; }),
        Api.get(
          `api/reports/getBestSellingProductsReports?startDate=${this.getDate(
            -30
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.productMonthly = r.data; }),
        Api.get(
          `api/reports/getHasAverage?startDate=${this.getDate(
            0
          )}&endDate=${this.getDate(+1)}`
        ).then((r) => { this.hasAverage = r.data; }),
        this.loadTotalGoldSentBetweenDates(),
      ]);
    },
    async loadTotalGoldSentBetweenDates() {
      this.goldSentLoading = true;
      try {
        const res = await Api.get(
          `api/orders/GetTotalGoldSentBetweenDates?startDate=${this.goldSentStartDate}&endDate=${this.goldSentEndDate}`
        );
        this.goldSentData = res.data || { totalGoldSent: 0, totalPayment: 0 };
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Gönderilen altın özeti yüklenirken hata:', err);
        this.goldSentData = { totalGoldSent: 0, totalPayment: 0 };
      } finally {
        this.goldSentLoading = false;
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async loadNewOrdersSummary() {
      this.newOrdersLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getNewOrdersBankSummary', {
          startDate: this.newOrdersStartDate,
          endDate: this.newOrdersEndDate
        });
        this.newOrdersSummary = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Yeni siparişler özeti yüklenirken hata:', error);
      } finally {
        this.newOrdersLoading = false;
      }
    },
    async loadCompletedOrdersSummary() {
      this.completedOrdersLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getCompletedOrdersBankSummary', {
          date: this.completedOrdersDate
        });
        this.completedOrdersSummary = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Tamamlanan siparişler özeti yüklenirken hata:', error);
      } finally {
        this.completedOrdersLoading = false;
      }
    },
    async loadEaltinOrderControl() {
      this.ealtinOrderControlLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getEaltinOrderListExcel', {
          date: this.ealtinOrderControlDate
        });
        this.ealtinOrderControlList = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Gün bazında sipariş kontrol listesi yüklenirken hata:', error);
      } finally {
        this.ealtinOrderControlLoading = false;
      }
    },
    async loadAltindafirsatOrderControl() {
      this.altindafirsatOrderControlLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getAltindafirsatOrderListExcel', {
          date: this.altindafirsatOrderControlDate
        });
        this.altindafirsatOrderControlList = data || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Altındafırsat gün bazında sipariş kontrol listesi yüklenirken hata:', error);
      } finally {
        this.altindafirsatOrderControlLoading = false;
      }
    },
    focusBarcodeInput() {
      this.$nextTick(() => {
        setTimeout(() => {
          const ref = this.$refs.barcodeInputRef;
          if (!ref) return;
          if (typeof ref.focus === 'function') {
            ref.focus();
            return;
          }
          if (ref.$el) {
            const input = ref.$el.querySelector('input');
            if (input) input.focus();
          }
        }, 100);
      });
    },
    onBarcodeInputBlur() {
      if (!this.barcodeDialogOpen) return;
      if (this.barcodeConfirming) return;
      this.focusBarcodeInput();
    },
    openBarcodeDialog() {
      this.barcodeInput = '';
      this.scannedBarcodes = [];
      this.barcodeConfirmResult = null;
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
      this.barcodeDialogOpen = true;
      this.focusBarcodeInput();
    },
    closeBarcodeDialog() {
      const hadConfirmed = !!(this.barcodeConfirmResult && this.barcodeConfirmResult.confirmed && this.barcodeConfirmResult.confirmed.length);
      this.barcodeDialogOpen = false;
      this.barcodeInput = '';
      this.scannedBarcodes = [];
      this.barcodeConfirmResult = null;
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
      if (this.duplicateFlashTimer) clearTimeout(this.duplicateFlashTimer);
      if (hadConfirmed) {
        this.loadAltindafirsatOrderControl();
        this.refreshMintSummary();
      }
    },
    refreshMintSummary() {
      const card = this.$refs.mintSummaryCard;
      if (card && typeof card.loadPlan === 'function') {
        card.loadPlan();
      }
    },
    addBarcode() {
      const value = (this.barcodeInput || '').trim();
      if (!value) {
        this.barcodeInput = '';
        return;
      }
      const existingIdx = this.scannedBarcodes.indexOf(value);
      if (existingIdx !== -1) {
        this.flashDuplicateBarcode(value, existingIdx);
      } else {
        this.scannedBarcodes.push(value);
        this.duplicateBarcodeWarning = null;
      }
      this.barcodeInput = '';
      this.focusBarcodeInput();
    },
    flashDuplicateBarcode(value, idx) {
      this.duplicateBarcodeWarning = value;
      this.duplicateFlashIdx = idx;
      if (this.duplicateFlashTimer) clearTimeout(this.duplicateFlashTimer);
      this.duplicateFlashTimer = setTimeout(() => {
        this.duplicateFlashIdx = null;
      }, 1800);
      this.playDuplicateBeep();
    },
    playDuplicateBeep() {
      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        const ctx = new AudioCtx();
        const now = ctx.currentTime;
        const beep = (start, freq) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'square';
          osc.frequency.value = freq;
          gain.gain.setValueAtTime(0.0001, start);
          gain.gain.exponentialRampToValueAtTime(0.2, start + 0.01);
          gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.12);
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.start(start);
          osc.stop(start + 0.14);
        };
        beep(now, 880);
        beep(now + 0.16, 660);
        setTimeout(() => {
          try { ctx.close(); } catch (e) { /* yut */ }
        }, 500);
      } catch (e) {
        /* yut */
      }
    },
    removeBarcode(idx) {
      this.scannedBarcodes.splice(idx, 1);
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
    },
    clearBarcodes() {
      this.scannedBarcodes = [];
      this.barcodeConfirmResult = null;
      this.duplicateBarcodeWarning = null;
      this.duplicateFlashIdx = null;
    },
    async confirmBarcodes() {
      if (!this.scannedBarcodes.length) return;
      this.barcodeConfirming = true;
      this.barcodeConfirmResult = null;
      try {
        const { data } = await orders.bulkConfirmBarcode(this.scannedBarcodes);
        this.barcodeConfirmResult = data || { confirmed: [], alreadyConfirmed: [], notFound: [], notShipped: [] };
        this.scannedBarcodes = [];
        if (this.barcodeConfirmResult.confirmed && this.barcodeConfirmResult.confirmed.length) {
          this.loadAltindafirsatOrderControl();
          this.refreshMintSummary();
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Barkod onaylama sırasında hata:', error);
      } finally {
        this.barcodeConfirming = false;
      }
    },
    formatDateTime(value) {
      if (!value) return '';
      const d = new Date(value);
      return d.toLocaleDateString('tr-TR') + ' ' +
        d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    },
    formatGold(value) {
      if (value === null || value === undefined) return '0.00 GR';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' GR';
    },
    formatNumber(value, digits = 2) {
      if (value === null || value === undefined) return '';
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(value);
    },
    formatGramTruncate(value) {
      if (value === null || value === undefined) return '';
      const num = Number(value);
      if (!isFinite(num)) return '';
      const fixed = num.toFixed(10);
      const [intPart, decPartRaw] = fixed.split('.');
      const decPart = (decPartRaw || '').slice(0, 2).padEnd(2, '0');
      const truncated = parseFloat(intPart + '.' + decPart);
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(truncated);
    },
    formatDateOnly(value) {
      if (!value) return '';
      return new Date(value).toLocaleDateString('tr-TR');
    }
  },
  async mounted() {
    const tasks = [this.initialize()];
    if (this.tenantId === 2) {
      tasks.push(
        this.loadNewOrdersSummary(),
        this.loadCompletedOrdersSummary(),
        this.loadEaltinOrderControl()
      );
    }
    if (this.tenantId === 1) {
      tasks.push(this.loadAltindafirsatOrderControl());
    }
    await Promise.all(tasks);
  },
};
</script>

<style scoped>
.ealtin-order-control-table >>> .v-datatable__wrapper,
.ealtin-order-control-table >>> .v-data-table__wrapper,
.ealtin-order-control-table >>> .v-table__overflow {
  overflow-x: auto;
}
.ealtin-order-control-table >>> table {
  min-width: 2200px;
}
.altindafirsat-order-control-table >>> .v-datatable__wrapper,
.altindafirsat-order-control-table >>> .v-data-table__wrapper,
.altindafirsat-order-control-table >>> .v-table__overflow {
  overflow-x: auto;
}
.altindafirsat-order-control-table >>> table {
  min-width: 3000px;
}
.text-no-wrap {
  white-space: nowrap;
}
@keyframes duplicate-flash {
  0% { background-color: #fff3e0; }
  30% { background-color: #ffb74d; }
  100% { background-color: transparent; }
}
.duplicate-flash {
  animation: duplicate-flash 1.8s ease-out;
}
</style>
